import React from "react";
import {Breadcrumbs, ConfirmResetPasswordPage, TextLinkAuthFrameFooter, useAuth} from "peggirkit";
import {authPageProps} from "@widgets/auth/AuthenticationPage";
import {useIntl} from "react-intl";
import router from "@/routing/Router";
import {ArrowUturnLeftIcon} from "@heroicons/react/20/solid";
import {useSearchParams} from "react-router-dom";
import {
    passwordScoreWords,
    passwordValidationLengths,
    togglePasswordVisibilityText
} from "@/utils/PasswordUtils";
import {api} from "@/data/api";


const ConfirmResetPassword = () => {
    const intl = useIntl();
    const [searchParams] = useSearchParams();
    const authContext = useAuth();
    const submitConfirmRequestReset = (newPassword: string): Promise<void> => new Promise((_, reject) => {
        const emailAddress = searchParams.get("emailAddress");
        const token = searchParams.get("token");
        if (emailAddress === null || token === null) {
            return reject();
        }

        api.auth.confirmPasswordReset(
            emailAddress,
            token,
            newPassword,
        ).then(() => {
            authContext?.signIn(emailAddress, newPassword).catch(() => {
                return reject()
            });
        }).catch(() => {
            return reject();
        });
    });

    return (
        <ConfirmResetPasswordPage
            {...authPageProps("setPassword", intl)}
            breadcrumbs={
                <Breadcrumbs
                    pages={[
                        {href: router.signIn.absolutePath(), name: intl.formatMessage({id: "signIn"})},
                        {href: router.confirmReset.absolutePath(), name: intl.formatMessage({id: "setPassword"})},
                    ]}
                    usePrevPageLink={true}
                    prevPageIcon={ArrowUturnLeftIcon}
                />
            }
            title={intl.formatMessage({id: "setPassword"})}
            description={intl.formatMessage({id: "setPasswordInstructions"})}
            footer={
                <TextLinkAuthFrameFooter
                    text={intl.formatMessage({id: "resetLinkExpired"})}
                    linkText={intl.formatMessage({id: "requestResetAgain"})}
                    linkAction={{href: router.reset.absolutePath()}}
                />
            }
            passwordField={{
                displayName: intl.formatMessage({id: "newPassword"}),
                inputControlProps: {
                    placeholder: "••••••••••••••••••",
                },
                options: {
                    required: intl.formatMessage({id: "enterAPassword"}),
                    ...passwordValidationLengths(intl),
                },
                showPasswordText: visible => togglePasswordVisibilityText(visible, intl),
            }}
            repeatPasswordField={{
                displayName: intl.formatMessage({id: "repeatPassword"}),
                options: {
                    required: intl.formatMessage({id: "repeatYourPassword"}),
                },
            }}
            passwordScoreWords={passwordScoreWords(intl)}
            errorMessage={intl.formatMessage({id: "couldNotResetPassword"})}
            successMessage={""}
            passwordsDoNotMatchMessage={intl.formatMessage({id: "passwordsMustMatch"})}
            submitButtonTxt={intl.formatMessage({id: "save"})}
            onSubmit={submitConfirmRequestReset}
        />
    );
};

export default ConfirmResetPassword;